import { clearHighlight } from "../direct.js";

export let FirstMenuLegend = {
  name: 'legend',
  title: 'Edit legend',
  shortcut: 'g'
}

export function findLegend(uid, legend, cls) {
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  let obj = document.querySelector(
    `#artboard-${uid} div[data-role="legend-replacement"][data-layer="${legend.layerIndex}"][data-channel="${legend.channel}"]`
  );
  if (cls === "unhide") { obj?.classList.remove(cls_name); }
  else { obj?.classList.add(cls_name); }
}
export function unfindLegend() {
  clearHighlight();
}